export default __webpack_public_path__ + "static/media/transit.872a469b.mp4";